import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Card, CardContent, CardHeader, Grid } from '@mui/material';

export default function AvisosEntidad() {
   // const { usuario, esJefe, esAsistente } = useDataContext()
   // console.log(`usuario de contexto ${JSON.stringify(usuario)}`)
    //console.log(`esJefe de contexto ${esJefe}`)
    //console.log(`esAsistente de contexto ${esAsistente}`)
    //const [solicitud, setSolicitud] = useState(null)


    const [avisosGestion, setAvisosGestion] = useState([])
    const [avisosPlaneacion, setAvisosPlaneacion] = useState([])
    const fecha = (new Date()).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" })


    useEffect(() => {
        (async () => {

            if (sessionStorage.getItem('idEntidad')) {
                const resAvisosGestion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos/gestion/${sessionStorage.getItem('idEntidad')}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const avisosGestionLeidos = await resAvisosGestion.json()
                
                setAvisosGestion(avisosGestionLeidos)

                const resAvisosPlaneacion = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/avisos/planeacion/${sessionStorage.getItem('idEntidad')}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const avisosPlaneacionLeidos = await resAvisosPlaneacion.json()                
                setAvisosPlaneacion(avisosPlaneacionLeidos)
            }

        })();
    }, []
    )

    return (
        <Grid container justifyContent='stretch' spacing={1} style={{ marginTop: 5 }}>
            <Grid item xs={12} sm={6}>
                <Card style={{ height: '100%', width: '100%' }}>
                    <CardHeader title='Avisos de gestión'></CardHeader>
                    <CardContent>
                        {avisosGestion.length === 0 ? 'Por el momento no hay avisos' :
                            avisosGestion.map((aviso) => (
                                <Alert key={aviso.id} severity={fecha === (new Date(aviso.createdAt)).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" }) ? "warning" : "info"} style={{ marginTop: 5 }}>
                                    <AlertTitle>{aviso.texto}</AlertTitle>
                                    <i>{aviso.responsableAviso}</i>   <div style={{ textAlign: 'right' }}><strong style={{ fontSize: '80%' }}>{(new Date(aviso.createdAt)).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" })}</strong></div>
                                </Alert>
                            ))}
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Card style={{ height: '100%', width: '100%' }}>
                    <CardHeader title='Avisos de planeación'></CardHeader>
                    <CardContent>
                        {avisosPlaneacion.length === 0 ? 'Por el momento no hay avisos' :
                            avisosPlaneacion.map((aviso) => (
                                <Alert key={aviso.id} severity={fecha === (new Date(aviso.createdAt)).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" }) ? "warning" : "info"} style={{ marginTop: 5 }}>
                                    <AlertTitle>{aviso.texto}</AlertTitle>
                                    <i>{aviso.responsableAviso}</i>   <div style={{ textAlign: 'right' }}><strong style={{ fontSize: '80%' }}>{(new Date(aviso.createdAt)).toLocaleDateString('es-MX', { day: "2-digit", month: "long", year: "numeric" })}</strong></div>
                                </Alert>
                            ))
                        }
                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    );
}